import { render, staticRenderFns } from "./banca.vue?vue&type=template&id=510b6b22&scoped=true&"
import script from "./banca.vue?vue&type=script&lang=js&"
export * from "./banca.vue?vue&type=script&lang=js&"
import style0 from "./banca.vue?vue&type=style&index=0&id=510b6b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b6b22",
  null
  
)

export default component.exports